import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import AppleLogin from "react-apple-login";
import { useGoogleLogin } from '@react-oauth/google';
import { fetchUserInfo } from '../../../utils/googleAuthUtils';
import SignUpHandler from '../../../Apihander/signup/signupHandler';
import SidebarContext from '../../../contexts/MyContext';
import SettingHandler from '../../../Apihander/setting/settingHandler';
import { gapi } from 'gapi-script';
import Modal from '../../../components/Modal/Modal';
import { OTPInput } from '../../../components/OTPInput/OTPInput';
import { successToast } from "../../../utils/notificationUtils";
import { errorToast } from "../../../utils/notificationUtils";
import LogOutHandler from "../../../Apihander/logOut/logoutHandler";
import '../../../css/accountSetting.css'

const { detect } = require('detect-browser');




const Account = () => {
  const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
  const { user, setUser, userAccountEmail, setUserAccountEmail, openOtpModal, setOpenOtpModal, storeUser, storeOtpUser, setPremiumStatus } = useContext(SidebarContext);
  const [load, setLoad] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [emailError, setEmailError] = useState('');
  const [otpValue, setOtpValue] = useState(''); // State to store OTP
  const [clearOtp, setClearOtp] = useState(false); // State to trigger OTP clearing
  const [countdown, setCountdown] = useState(59);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null);
  const [initialUserAccountEmail, setInitialUserAccountEmail] = useState(userAccountEmail);

  const [updatedAccountEmail, setUpdatedAccountEmail] = useState(null);
  const [updateEmailload, setUpdateEmailLoad] = useState(false)

  const detectbrowser = detect();
  // Brave detection logic
  let detectDeviceName = detectbrowser?.name || "unknown";

  // Check for Brave specifics
  if (detectbrowser?.name === 'chrome') {
    // Additional checks for Brave
    if (navigator.brave || window.navigator.userAgent.includes('Brave')) {
      detectDeviceName = 'brave';
    }
  }
  const navigate = useNavigate();



  const onsubmit = () => {

  }

  const login = useGoogleLogin({

  });


  const handleAppleLoginSuccess = async (response) => {


  };

  const handleAppleLoginError = (error) => {
    console.error('Apple login error:', error);
  };


  const getUserDeivceInfo = async () => {
    const data = await SettingHandler.doHandlerGetUserDeviceInfo()
    // console.log(data, 'datadatadatauserInfo')
    setDeviceData(data?.data)
  }
  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Helper function to map device type to icon path
  const getIconPath = (deviceType) => {
    switch (deviceType?.toLowerCase()) {
      case 'chrome':
        return '../img/accountsetting/googleChrome.png';
      case 'firefox':
        return '../img/accountsetting/firefox.png';
      case 'android':
        return '../img/accountsetting/android.png';
      case 'macos':
        return '../img/accountsetting/macOS.png';
      case 'iphone':
        return '../img/accountsetting/iPhone.png';
      case 'safari':
        return '../img/accountsetting/safari.png';
      case 'brave':
        return '../img/accountsetting/simpleiconsbrave.png';
      case 'edge-chromium':
        return '../img/accountsetting/edge.png';
      default:
        // return '../img/accountsetting/default.png';
        return 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cmVjdCB4PSIyIiB5PSIzIiB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHJ4PSIyIiByeT0iMiI+PC9yZWN0PjxsaW5lIHgxPSI2IiB5MT0iMjAiIHgyPSIxOCIgeTI9IjIwIj48L2xpbmU+PC9zdmc+';
    }
  };
  useEffect(() => {
    getUserDeivceInfo()
  }, [])

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer); // Stop the timer when reaching 0
          }
          return prev - 1;
        });
      }, 1000);
    }

    // Cleanup timer when the component unmounts or countdown changes
    return () => clearInterval(timer);
  }, [countdown]);

  // Start the countdown when the modal opens
  useEffect(() => {
    if (openOtpModal) {
      const newEmail = localStorage.getItem('userAccountUpdatedEmail')

      setUpdatedAccountEmail(newEmail)
      startCountdown();
    }
  }, [openOtpModal]);

  useEffect(() => {
    if (userAccountEmail && initialUserAccountEmail === null) {
      setInitialUserAccountEmail(userAccountEmail);
    }
  }, [userAccountEmail, initialUserAccountEmail]);


  const getUserEmailInfo = () => {
    if (user) {
      if (user?.isGoogle) {
        return (`You are logged in with your google account ${user?.email}.`)
      }
      else if (user?.isApple) {
        return (`You are logged in with your apple account ${user?.email}.`)
      }
      else {
        return ("")
      }
    }
  }

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email)?.toLowerCase());
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;

    setUserAccountEmail(emailValue);

    if (!validateEmail(emailValue)) {
      setEmailError('Enter valid email address');
    } else {
      setEmailError('');
    }
  }

  const handleAccountDetails = async (e) => {
    e.preventDefault();

    try {
      setLoad(true)
      const payloadData = {
        email: userAccountEmail
      }

      const data = await SettingHandler.doHandleUserAccountEmail(payloadData)

      if (data && data?.statusCode == 200) {
        localStorage.setItem("userAccountUpdatedEmail", userAccountEmail);
        setOpenOtpModal(true)
        setLoad(false)

      }
      else {
        const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
        errorToast(errorMessage);
        setLoad(false)

      }
    } catch (error) {
      console.error('Error:', error);
      setUpdateEmailLoad(false)


    }

  }

  const handleOtpSubmit = async () => {
    setLoading(true);
    setError(null);
    const payload = {
      'email': updatedAccountEmail,
      'otp': otpValue
    }
    try {
      const data = await SignUpHandler.doHandlerOtpSubmit(payload)
      if (data?.statusCode === 200) {
        successToast(data?.message)
        // successToast('Email updated successfully')
        await handleLogOut()
      }

      else {
        // console.error('OTP verification failed:', data.message);
        const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
        // setError(errorMessage);
        errorToast(errorMessage);
        setLoading(false)
      }
    } catch (err) {
      setLoading(false);
      // setError('An error occurred while verifying the OTP.');
      console.error('Error:', err);
    }
  };

  const handleResendOtp = async () => {
    setLoad(true)
    try {
      const data = await SignUpHandler.doHandlerResendOtpSubmit()
      if (data.statusCode === 200) {
        // Handle successful OTP verification, e.g., close the modal or navigate
        startCountdown(); // Restart the countdown timer when OTP is resent successfully
        setClearOtp(false); // Temporarily set to false to force reset
        setTimeout(() => {
          setClearOtp(true); // Set back to true to clear the input
        }, 0);
        successToast(data?.message)
        setLoad(false)
        // setError('')
      } else {
        const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
        errorToast(errorMessage);
        setLoad(false)
        // setError(errorMessage);

      }
    } catch (err) {
      setLoading(false);
      // setError('An error occurred while verifying the OTP.');
      console.error('Error:', err);
      setLoad(false)

    }
  }

  const startCountdown = () => {
    setCountdown(59); // Reset the countdown to 59 seconds
    setOtpValue('')
    setClearOtp(true); // Set clearOtp to true to reset the input

  };




  const handleLogOut = async () => {
    try {
      const payload = {
        deviceType: detectbrowser.type,
        deviceName: detectDeviceName
      }
      await LogOutHandler.doHandelLogOut(payload)


      // successToast("Email updated and verified successfully");

      await new Promise((resolve) => {

        localStorage.removeItem('currentUser')
        localStorage.removeItem('userAccountUpdatedEmail')

        setOtpValue('');
        setClearOtp(true); // Set clearOtp to true to reset the input
        setOpenOtpModal(false);
        setLoading(false);
        resolve(); // Wait for all state actions to complete before navigating
      });

      navigate("/", { replace: true });
      setPremiumStatus(null)
      setUser(null);

    } catch (error) {
      console.log("🚀 ~ getSetting ~ error:", error)

    }
  };

  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Account Overview
      </h2>
      <div className='vr-set-card'>
        <div>
          <form
            className="custom-modal-form vr-set-form"
            action=""
            method=""
            // onSubmit={handleSubmit(onsubmit)}
            onSubmit={handleAccountDetails}
            noValidate
          >
            <div className="form-group vr-set-field">
              <label className="vr-set-label" htmlFor="email">Email</label>
              {!user?.isGoogle && !user?.isApple ?
                <>
                  <input
                    type="email"
                    className={`vr-input vr-set-input ${errors.email ? 'is-error' : ''}`}
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Enter your email"
                    name="email"
                    // value={user?.email}
                    value={userAccountEmail}
                    {...register("email", {
                      required: 'Email address is required',
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: 'Enter a valid email address'
                      }
                    })}
                    onChange={handleEmailChange}

                  />
                  {emailError && <p className="error-message vr-set-error">{emailError}</p>}
                </>
                :
                <>
                  <span className="vr-set-note">{getUserEmailInfo()}</span>
                </>
              }

              {errors.email && <span className="error-message vr-set-error">{errors.email.message}</span>}
            </div>
            {/* <div className="" style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', color: '#334155', marginLeft: '10px' }}>
              <p className="text-md main-heading-login" style={{ fontSize: '20px', fontWeight: '600', color: '#2C3E5D' }} >
                Social Profiles
              </p>
            </div> */}
            {/* <div className="">
              <AppleLogin
                clientId="com.your.client-id" // Replace with your actual client ID
                redirectURI="https://your.redirect.uri" // Replace with your actual redirect URI
                usePopup={true} // Use a popup for the login
                responseType="code" // You can also use "id_token" or "both"
                responseMode="query" // "query" or "fragment"
                scope="name email" // Scopes you want to access
                onSuccess={handleAppleLoginSuccess}
                onError={handleAppleLoginError}
                render={(props) => (
                  <div className="form-group m-2 social-group" onClick={props.onClick}>
                    <button
                      type="button"
                      className="social-btn"
                      disabled={props.disabled} // Disable the button if necessary
                      style={{ justifyContent: 'start', paddingLeft: "10px" }}
                    >
                      <div style={{ padding: '10px 12px', background: '#ffffff', borderRadius: '8px' }}>
                        <img
                          src="../img/login/apple_icon.png"
                          alt="Apple"
                          className="social-img"
                          style={{ marginRight: '0px' }}
                        />
                      </div>
                      <span style={{
                        fontSize: '16px', fontWeight: '500', color: '#334155', paddingLeft: '10px', fontFamily: 'metropolis'
                      }}>
                        Connect with Apple
                      </span>
                    </button>
                  </div>
                )}
              />
            </div> */}
            {/* <div className="form-group m-2 social-group">
              <button
                type="button"
                className="social-btn"
                style={{ justifyContent: 'start', paddingLeft: "10px", background:'#ffffff', border:'1px solid #E2E8F0', borderRadius:'8px' }}
              >
                <div style={{ padding: '10px 12px', background: '#F1F5F9', borderRadius: '8px' }}>
                  <img
                    src="../img/login/google_icon.png"
                    alt="google"
                    className="social-img"
                    style={{background:'#F1F5F9', marginRight:'0px'}}
                  />
                </div>
                <span style={{
                  fontSize: '16px', fontWeight: '500', color: '#334155', paddingLeft: '10px', fontFamily: 'metropolis'
                }}>
                  Connect with Google
                </span>
              </button>
            </div> */}
            {
              !user?.isGoogle && !user?.isApple &&
              <div className="form-group vr-set-actions">
                <button
                  type="submit"
                  className="vr-btn vr-btn-primary vr-btn-lg"

                  // disabled={load}
                  // style={{ cursor: load ? 'not-allowed' : 'pointer', width: '50%' }}

                  disabled={emailError || initialUserAccountEmail == userAccountEmail}
                  style={{
                    cursor: (emailError || initialUserAccountEmail == userAccountEmail) ? 'not-allowed' : 'pointer',
                  }}


                >



                  {load ? (
                    <>
                      <span style={{ marginRight: '10px' }}></span>

                      <div
                        className="spinner-border vr-set-spin"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <span>
                        Save Changes
                      </span>
                    </>
                  )
                  }
                </button>
              </div>
            }
          </form>
        </div>
      </div>
      <div className='vr-set-card'>
          <div>
            <div className="">
              <h3 className="vr-set-card-title">
                Logged-in devices
              </h3>
              {/* <ul style={{ paddingLeft: '0px', marginTop: '10px', overflowY: 'auto', height: '150px' }} className="scroll">
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <img
                    src="../img/accountsetting/android.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Android
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src="../img/accountsetting/googleChrome.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Google Chrome
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src="../img/accountsetting/macOS.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      macOS
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src="../img/accountsetting/iPhone.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      iPhone
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src="../img/accountsetting/safari.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Safari
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <img
                    src="../img/accountsetting/firefox.png"
                    alt="Android Icon"
                    className="Settingicon"
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      FireFox
                    </span>
                    <span
                      style={{
                        fontFamily: 'Metropolis',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '-4%',
                        color: '#64748B',
                      }}
                    >
                      Last Logged in today at 7:41pm
                    </span>
                  </div>
                </li>
              </ul> */}
              <ul className="vr-set-devices">
                {deviceData?.slice().reverse().map((device) => (
                  <>
                    <li key={device?._id} className="vr-set-device">
                      <span className="vr-set-device-icon">
                        <img
                          src={getIconPath(device?.deviceName)}
                          // alt={`${device?.deviceName} Icon`}
                          alt='icon'
                        />
                      </span>
                      <div className="vr-set-device-meta">
                        <span className="vr-set-device-name">
                          {device?.deviceName?.charAt(0)?.toUpperCase() + device?.deviceName?.slice(1)}
                        </span>
                        <span className="vr-set-device-time">
                          Last Logged in on {formatDate(device?.loginTime)}
                        </span>
                      </div>
                    </li>

                  </>
                ))}
              </ul>
            </div>
          </div>
      </div>


      {/* OTP modal */}

      {
        openOtpModal && (
          <Modal
            onClose={(e) => {
              setOpenOtpModal(false);
            }}
            modaltxt={"Verify OTP"}
          >
            <div>
              <div className="form-group">
                <p className="vr-set-otp-text">A verification OTP has been sent to <span className="vr-set-otp-email">{updatedAccountEmail}</span>.Please check your mailbox to verify the account before you start using the services.</p>
              </div>
              <div className="form-group vr-set-otp">
                <OTPInput length={6} onOtpChange={setOtpValue} clearOtp={clearOtp} />
              </div>
              {error && <p className="vr-set-error">{error}</p>}
              <div className={`vr-set-resend ${countdown > 0 ? 'is-wait' : ''}`}
                onClick={() => {
                  if (countdown === 0 && !load) {
                    handleResendOtp();
                    setOtpValue('');
                  }

                }}
              >
                <a>{countdown > 0 ? `Resend OTP in 00:${countdown < 10 ? `0${countdown}` : countdown}` : load ? ' OTP Sending...' : 'Resend OTP'}</a>
              </div>
              <div className="form-group vr-set-modal-actions">
                <button
                  type="submit"
                  className="vr-btn vr-btn-primary vr-btn-block"
                  onClick={() => { handleOtpSubmit() }}
                  disabled={otpValue.length < 6 || loading}
                  style={{
                    cursor: otpValue.length < 6 || loading ? "not-allowed" : "pointer",
                  }}

                >

                  {loading ? (
                    <>
                      <span style={{ marginRight: '10px' }}>Saving</span>
                      <div
                        className="spinner-border vr-set-spin"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <span>
                        Submit
                      </span>
                    </>
                  )
                  }
                </button>
              </div>
            </div>
          </Modal >
        )
      }

    </div>
  )
}

export default Account
